import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mapTo } from 'rxjs';
import {
  SaveInvoiceStatusWidgetConfigurationRequest,
  InvoiceStatusConfiguration
} from '@feature/invoice-status/invoice-status-widget-types';
import { UrlBuilderService } from '@common/services/url-builder.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ITable } from '@common/models/table';

@Injectable({
  providedIn: 'root'
})
export class InvoiceStatusWidgetHttpService {

  constructor(
    private readonly urlProvider: UrlBuilderService,
    private readonly http: HttpClient
  ) { }

  getInvoiceData(widgetInstanceId: number, supplierRef: number, creditorUri: number, external: boolean): Observable<ITable> {
    let httpParams = new HttpParams();
    if (creditorUri) { httpParams = httpParams.append('CreditorUri', String(creditorUri)); }
    if (supplierRef) { httpParams = httpParams.append('SupplierRef', String(supplierRef)); }
    const url = this.urlProvider.getUrl(`invoice-status/${widgetInstanceId}/${external}/query` );
    return this.http.get<ITable>(url, { params: httpParams });
  }

  getItemLevelData(widgetInstanceId: number, payablesRegisterUri: number, external: boolean): Observable<ITable> {
    const url = this.urlProvider.getUrl(`invoice-status/item-level/${widgetInstanceId}/${external}/${payablesRegisterUri}/query`);
    return this.http.get<ITable>(url);
  }

  getWidgetConfiguration(widgetConfigurationId: number) {
    const url = this.urlProvider.getUrl(`invoice-status/config/${widgetConfigurationId}`);
    return this.http.get<InvoiceStatusConfiguration>(url);
  }

  copyWidgetConfiguration(request: SaveInvoiceStatusWidgetConfigurationRequest) {
    const url = this.urlProvider.getUrl('invoice-status/config/copy');
    return this.http.post(url, request).pipe(mapTo(true));
  }

  saveWidgetConfiguration(request: SaveInvoiceStatusWidgetConfigurationRequest) {
    const url = this.urlProvider.getUrl('invoice-status/config');
    return this.http.post(url, request).pipe(mapTo(true));
  }


}
